<template>
  <div class="mains">
    <div class="campus">
      教务管理
      <span>></span>班级管理
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="xiaoqu_1">全部班级</div>
          <el-button type="primary" class="buttons" @click="addClass1">
            <span>+</span> 新建班级
          </el-button>
          <div class="sousuo">
            <span>创建时间：</span>
            <el-date-picker class="pickers" v-model="timetotime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            <span>班级名称：</span>
            <el-input v-model="orgname" @keyup.13.native="chaxun" placeholder="请输入班级名称"></el-input>
            <el-button type="primary" class="buttons" @click="chaxun()">查 询</el-button>
          </div>

          <el-dialog title="新建班级" :visible.sync="addStudents" width="600px">
            <div class="form_1 form_1_1">
              <el-form ref="forms" :model="forms" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="班级名称" prop="name">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="forms.name" placeholder="请输入班级名称"></el-input>
                </el-form-item>
                <el-form-item label="班级封面">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" style="left: -5vw; top: 0.78125vw" alt />
                  </i>
                  <el-upload class="avatar-uploader" action style="margin-left: 10px" :show-file-list="false">
                    <el-button type="primary" class="banji_ht">更换图片</el-button>
                    <div class="banji_tu">
                      <img src="@/assets/img/education-manage/classs/shangchuan.png" class="avatar" width="140" height="140" />
                    </div>
                  </el-upload>
                  <div class="jianyi">
                    <span>( 建议：JPG或PNG图片， 推荐：400*400)</span>
                  </div>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="addClass">确定</el-button>
                  <el-button @click="quxiao">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog title="编辑班级" :visible.sync="addStudentss" width="600px">
            <div class="form_1 form_1_1">
              <el-form ref="forms" :model="forms1" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="班级名称" prop="name">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="forms1.name" placeholder="请输入班级名称"></el-input>
                </el-form-item>
                <el-form-item label="班级封面">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" style="left: -5vw; top: 0.78125vw" alt />
                  </i>
                  <el-upload class="avatar-uploader" action style="margin-left: 10px" :show-file-list="false">
                    <el-button type="primary" class="banji_ht">更换图片</el-button>
                    <div class="banji_tu">
                      <img src="@/assets/img/education-manage/classs/shangchuan.png" class="avatar" width="140" height="140" />
                    </div>
                  </el-upload>
                  <div class="jianyi">
                    <span>( 建议：JPG或PNG图片， 推荐：400*400)</span>
                  </div>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="updateEduClass">确定</el-button>
                  <el-button @click="quxiao">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog title="班级邀请码" :visible.sync="getEduClassByIds" width="600px">
            <div class="form_1 form_1_1">
              <el-form ref="forms" :model="forms2" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="邀请码" prop="invite_code">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" class="sangezi" alt />
                  </i>
                  <el-input v-model="forms2.invite_code" placeholder="请输入班级邀请码"></el-input>
                </el-form-item>
                <el-form-item class="queding invite_code">
                  <el-button class="copy" type="primary" @click="Copy">复制邀请码</el-button>
                  <el-button class="copy" @click="refreshEduClassInviteCode">重新生成</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>

          <div class="zsbg">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop label="班级形象" max-width="360">
                <img src="@/assets/img/education-manage/classs/logo.png" alt />
              </el-table-column>
              <el-table-column prop="name" label="班级名称" min-width="50">
                <template slot-scope="scope">
                  <el-link @click="banji_ming(scope.row)">
                    {{ scope.row.name }}
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column prop="showCreateTime" label="创建时间"></el-table-column>
              <el-table-column prop="student_num" label="学员数"></el-table-column>
              <el-table-column prop="emp_num" label="员工数"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="stData">
                  <!--<el-button type="text">APP下载页</el-button>-->
                  <el-button type="text" @click="updateOrgs(stData.row.id)">班级邀请码</el-button>
                  <el-button type="text" @click="updateOrg(stData.row.id)">编辑</el-button>
                  <el-button type="text" @click="del(stData.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'classs',
  data() {
    return {
      orgname: '',
      gridData: [],
      tableData: [],
      searchData: [],
      timetotime: '',
      FormRules: {
        name: [{ required: true, message: '请您填写必填信息' }]
      },
      // 检索表单数据对象
      page: 1,
      pageSize: 5,
      currentPage: 1,
      disablePage: false,
      total: 0,
      dialogTableVisible: false,
      addStudents: false,
      addStudentss: false,
      getEduClassByIds: false,
      forms: {},
      forms1: {},
      forms2: {},
      refreshEduClassInviteCode_Id: ''
    };
  },
  mounted() {
    this.chaxun();
  },
  watch: {
    timetotime() {
      this.chaxun();
    }
  },
  methods: {
    chaxun() {
      let timetotime = this.timetotime;
      let fromtime = '';
      let totime = '';
      let orgname = this.orgname;
      if (timetotime !== '' && timetotime !== null) {
        let size = timetotime.length;
        // console.log(size)
        if (size === 1) {
          fromtime = timetotime[0];
        } else if (size === 2) {
          fromtime = timetotime[0];
          totime = timetotime[1];
        }
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/class/selectClassPage',
        method: 'POST',
        data: {
          orgid: orgid,
          fromtime: fromtime,
          totime: totime,
          name: orgname,
          page: this.page,
          pageSize: this.pageSize
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          var data = result.data.data;
          this.tableData = data;
          // console.log(data)
          this.disablePage = true;
          if (data === undefined || data === null) {
            this.total = 0;
          } else {
            this.total = result.data.size;
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得班级信息失败：' + err);
        });
      // console.log(this.searchData)
    },
    addClass1() {
      this.addStudents = true;
    },
    addClass() {
      this.$refs.forms.validate(valid => {
        if (!valid) {
          return false;
        }
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let orgid = window.sessionStorage.getItem('orgid');
        let pro = this.$http({
          url: '/edu/class/addClass',
          method: 'POST',
          data: {
            orgid: orgid,
            name: this.forms.name,
            image_url: ''
          },
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.addStudents = false;
            this.chaxun();
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('新增班级失败：' + err);
          });
      });
    },
    quxiao() {
      if (this.addStudentss) {
        this.addStudentss = false;
      }
      if (this.addStudents) {
        this.addStudents = false;
      }
    },
    // 获取班级信息
    updateOrg(id) {
      // console.log(id)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/class/getEduClassById/' + id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.forms1 = result.data.data;
          this.addStudentss = true;
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获取班级信息失败：' + err);
        });
      // this.$router.push({ path: '/campusedit' })
    },
    // 复制成功
    Copy() {
      var Input = document.createElement('input'); // 创建一个隐藏input
      Input.value = this.forms2.invite_code; // 赋值
      document.execCommand('Copy'); // 执行浏览器复制命令
      this.$message({ message: '复制成功', type: 'success' });
    },

    // 重新生成班级邀请码
    refreshEduClassInviteCode() {
      var id1 = this.refreshEduClassInviteCode_Id;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/class/refreshEduClassInviteCode/' + id1,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.forms2.invite_code = result.data.data;
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('重新生成班级邀请码失败：' + err);
        });
    },
    updateOrgs(id) {
      this.refreshEduClassInviteCode_Id = id;
      this.getEduClassByIds = true;
      for (var i = 0; i < this.tableData.length; i++) {
        if (id === this.tableData[i].id) {
          this.forms2 = this.tableData[i];
        }
      }
    },
    // 修改班级
    updateEduClass() {
      this.$refs.forms.validate(valid => {
        if (!valid) {
          return false;
        }
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let orgid = window.sessionStorage.getItem('orgid');
        let pro = this.$http({
          url: '/edu/class/updateEduClass',
          method: 'POST',
          data: {
            id: this.forms1.id,
            orgid: orgid,
            name: this.forms1.name,
            image_url: ''
          },
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.addStudentss = false;
            this.chaxun();
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('修改班级失败：' + err);
          });
      });
    },
    banji_ming(id) {
      // console.log(id)
      this.$store.commit('banji_ming', id);
      this.$router.push({
        path: '/studentemplist'
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      // this.$options.methods.chaxun()
      this.chaxun();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.chaxun();
    },
    // 删除
    del(id) {
      // 确认事情
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // axios请求服务器端实现删除
        let pro = this.$http({
          url: '/edu/class/deleteEduClass/' + id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // 删除成功
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.chaxun();
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('删除校区失败：' + err);
          });
      });
    }
  }
};
</script>

<style lang="less">
.mains {
  .campus {
    // width: 28px;
    // height: 20px;
    font-family: PingFang SC;
    font-size: 14px;
    color: #666666ff;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 10px;
    span {
      margin: 0 10px 0 8px;
    }
  }
  .sangezi {
    left: -84px !important;
  }
  .invite_code {
    margin-left: 0 !important;
  }
  .copy {
    width: 130px !important;
    height: 40px !important;
    font-size: 16px !important;
  }
  .banji_ht {
    width: 77px !important;
    height: 33px !important;
    font-size: 8px !important;
    margin: 4px 0 0 10px !important;
    float: left;
    border-radius: 4px !important;
    padding: 2px 0 0 2px !important;
  }
  .jianyi {
    font-size: 12px !important;
    color: #cccccc;
    position: absolute;
    top: 0;
    left: 135px;
  }
  .banji_tu {
    img {
      width: 160px;
      height: 160px;
    }
  }
  .el-button--text:active {
    color: #00a6e6;
  }
  .el-button--text {
    color: #00a6e6;
  }
}
</style>
